import { useIntl } from 'react-intl';

import { useMultiFlightMap } from '../../../MultiFlightMap.context';
import { useLocationFilters } from './useLocationFilters';

import type { CartographyItemInfo } from '../../../grouping/domain/cartographyGrouping';
import type { FilterPanelConfig } from './filters.types';

type Attributes = Omit<FilterPanelConfig['attributes'], 'icon' | 'title'>;

/** Same glyphs the map draws for each kind of item: the screen icon, the attribution POI pin and the proximity point. */
const attributesIcon = (family: 'screens' | 'venues', activeSubsection: string | null): string => {
  if (family === 'screens') {
    return 'fa-kit fa-screen';
  }
  return activeSubsection === 'proximityPoints' ? 'fa-solid fa-thumbtack' : 'fa-solid fa-location-dot';
};

/** Filters panel of the screens and venues lists: Location plus the attributes the list brings. */
export function useListFilterPanel(
  family: 'screens' | 'venues',
  items: CartographyItemInfo[],
  attributes: Attributes
): { matches: (item: CartographyItemInfo) => boolean; panel: FilterPanelConfig } {
  const { formatMessage } = useIntl();
  const { activeSubsection } = useMultiFlightMap();
  const { location, matches } = useLocationFilters(family, items);

  const title =
    family === 'screens'
      ? formatMessage({ defaultMessage: 'Screen attributes', id: 'multiFlightListsMap.filters.screenAttributes.title' })
      : formatMessage({ defaultMessage: 'POI attributes', id: 'multiFlightListsMap.filters.poiAttributes.title' });

  return {
    matches,
    panel: { attributes: { ...attributes, icon: attributesIcon(family, activeSubsection), title }, location }
  };
}
